import { useCallback } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";

function useSaveTransaction() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const saveTransaction = useCallback(
    (
      plates,
      transactionInfo,
      resetOnSave,
      transactionSuccess,
      transactionFailed
    ) => {
      fetchWrapper({
        endpoint_url: "transaction/saveTransaction",
        params: {
          plates: plates,
          transaction_info: transactionInfo,
        },
        onSuccess: (fetch_output) => {
          if (!("error" in fetch_output)) {
            transactionSuccess(resetOnSave);
            showMessage({ type: "success", message: "Payment Successfully" });
          } else {
            transactionFailed();
          }
        },
        onFetchError: () => transactionFailed(),
        onResponseError: () => transactionFailed(),
      });
    },
    [fetchWrapper]
  );

  return { saveTransaction };
}

export default useSaveTransaction;
